import EventEmitter from 'events';
import io, { Socket } from 'socket.io-client';

import { IS_DEMO } from '../config';

export const socket = !IS_DEMO
  ? io({ path: '/core/socket.io' }).connect()
  : (new EventEmitter() as unknown as Socket);
